import React from 'react';
import { useOrganization } from '../../contexts/OrganizationContext';
import { TopBar } from '../../components/TopBar/TopBar';
import './DonationAgreementView.css';

interface DonationAgreementViewProps {
  onBack: () => void;
}

/**
 * 捐赠协议页面
 */
export const DonationAgreementView: React.FC<DonationAgreementViewProps> = ({ onBack }) => {
  const { organization } = useOrganization();
  const donationAgreement = organization?.donationAgreement || '';

  return (
    <div className="donation-agreement-view">
      <TopBar title="捐赠协议" showBack onBack={onBack} />
      <div className="donation-agreement-content">
        {donationAgreement ? (
          <div 
            className="agreement-html" 
            dangerouslySetInnerHTML={{ __html: donationAgreement }}
          />
        ) : (
          <div className="agreement-empty">暂无捐赠协议内容</div>
        )}
      </div>
    </div>
  );
};

